var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "136",
        viewBox: "0 0 178 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M177.151 136.002V0H0V136.002H177.151Z", fill: "#B42A8A" },
      }),
      _c("path", {
        attrs: {
          d: "M0.00195312 136.002V0.658203L176.295 136.002H0.00195312Z",
          fill: "#D064B6",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }